
import Vuex from 'vuex';
import gql from 'graphql-tag'

import graphqlClient from './graphql';

export const mutations = {
  setUserLog(state, UserLog) {
    state.user_log = UserLog;
  },
  setIsAuthenticatedLog(state, data) {
    state.is_authenticated = data.isAuthenticated;
    state.is_admin = data.isAdmin;
    state.rules = data.rules;
    state.infos = data.infos;
  },
};

export const actions = {
  async fetchUser({ commit }) {
    const response = await graphqlClient.query({
      query: gql`
        { user {
          id
          username
          is_authenticated:isAuthenticated
        }
        }
      `,
    });
    commit('setUserLog', response.data.user);
  },
  async fetchIsAuthenticated({ commit }) {
    const response = await graphqlClient.query({
      query: gql` {
      isAuthenticated
      isAdmin
      rules{
        id
        title
      }
      infos{
        id
        title
      }
    }`,
      update: data => [data.isAuthenticated,data.isAdmin, data.rules, data.infos]
    });
    commit('setIsAuthenticatedLog', response.data);
  },
};

export const state = {
  noti: null,
};

export default new Vuex.Store({
  mutations,
  actions,
  state,
});